<div class="oa-sheet">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>{{ data.title }}</h2>
        <button type="button" class="oa-icon-btn" (click)="dialogRef.close()" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__search" *ngIf="searchable">
        <label class="oa-search">
            <mat-icon aria-hidden="true">search</mat-icon>
            <input #searchInput type="search" autocomplete="off" enterkeyhint="search"
                [placeholder]="data.searchPlaceholder || 'Buscar'" [attr.aria-label]="data.searchPlaceholder || 'Buscar'"
                [value]="term" (input)="onSearch($any($event.target).value)">
            <button *ngIf="term" type="button" class="oa-icon-btn oa-icon-btn--sm picker-clear"
                (click)="clearSearch()" aria-label="Limpar busca">
                <mat-icon>close</mat-icon>
            </button>
        </label>
    </div>

    <div class="oa-sheet__body oa-sheet__body--flush" (scroll)="onScroll($any($event.target))">
        <ul class="oa-option-list" role="listbox" [attr.aria-label]="data.title" #list>
            <li *ngFor="let option of filtered; trackBy: trackByIndex" role="none">
                <button type="button" class="oa-option" role="option"
                    [attr.aria-selected]="isSelected(option)" (click)="select(option)">
                    <img *ngIf="option.thumb" class="oa-option__thumb" [src]="option.thumb" alt="" loading="lazy">
                    <span class="oa-option__text">
                        <span class="oa-option__title">{{ option.title }}</span>
                        <span class="oa-option__meta" *ngIf="option.meta">{{ option.meta }}</span>
                    </span>
                    <mat-icon *ngIf="isSelected(option)" class="oa-option__check" aria-hidden="true">check</mat-icon>
                </button>
            </li>
        </ul>
        <div class="oa-option-loading" *ngIf="loading" role="status">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Carregando...</span>
        </div>
        <div class="oa-option-empty" *ngIf="!filtered.length && !loading" role="status">
            {{ term ? 'Nada encontrado para "' + term + '".' : (data.emptyText || 'Nenhuma opção.') }}
            <div class="picker-empty-create" *ngIf="emptyCreateLabel as label">
                <button type="button" class="oa-btn oa-btn--primary" (click)="create()">
                    <mat-icon *ngIf="data.createIcon">{{ data.createIcon }}</mat-icon>
                    {{ label }}
                </button>
            </div>
        </div>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" (click)="dialogRef.close()">Cancelar</button>
        <button *ngIf="data.createLabel" type="button" class="oa-btn oa-btn--secondary" (click)="create()">
            <mat-icon *ngIf="data.createIcon">{{ data.createIcon }}</mat-icon>
            {{ data.createLabel }}
        </button>
    </footer>
</div>
